import { PDFDocument, PDFFont, PageSizes } from "pdf-lib";
import { PageContent, PageSize, TemplateContent } from "../types";
import { fetchImage, getXPosition, getYPosition } from "./helpers";
import { drawTemplateOnPage } from "./drawTemplateOnPage";

export const drawDocumentImagePage = async (
  pdfDoc: PDFDocument,
  font: PDFFont,
  data: PageContent,
  url: string,
  size: PageSize,
  templateData?: TemplateContent
) => {
  try {
    let pageDimensions: [number, number] =
      templateData?.orientation === "landscape"
        ? [PageSizes[size as PageSize][1], PageSizes[size as PageSize][0]]
        : PageSizes[size];

    const page = pdfDoc.addPage(pageDimensions);

    const { width, height } = page.getSize();

    const documentImageBytes = await fetchImage(url);

    const docImage = url?.includes("png")
      ? await pdfDoc.embedPng(documentImageBytes)
      : await pdfDoc.embedJpg(documentImageBytes);

    let topSide = templateData?.margin?.top_offset || 5;
    let widthSide = templateData?.margin?.width_offset || 5;
    let bottomSide = templateData?.margin?.bottom_offset || 5;

    const scaledImageDimensions = docImage.scaleToFit(
      width - (2 * widthSide * width) / 100 - 2 * widthSide,
      height - ((topSide + bottomSide) * height) / 100 - (topSide + bottomSide)
    );

    let startXPosition = getXPosition(
      width,
      templateData?.margin?.width_offset || 5
    );
    let startYPosition = getYPosition(height, topSide);

    page.drawImage(docImage, {
      x: startXPosition + 5,
      y: height - scaledImageDimensions.height - (startYPosition + 5),
      width: scaledImageDimensions.width,
      height: scaledImageDimensions.height,
    });

    // Render Template
    await drawTemplateOnPage(
      pdfDoc,
      page,
      templateData,
      font,
      data?.sequence_id?.includes("BOM"),
      data
    );

    return page;
  } catch (error: any) {
    console.error(`Error loading document on preview: ${error}`);
    // return await drawNoPreviewPage(pdfDoc, size);
  }
};
